module.exports = "<div id=breadcrumb-container class=transparent><div class=container><div class=row><div class=\"col-md-9 col-sm-8 col-xs-12\"><ul class=breadcrumb><li><a ui-sref={{shCtrl.ngAuthSettings.site.app.header.logo.url}}>Inicio</a><li class=active><span>Términos y condiciones</span></ul></div></div></div></div><div class=container><div class=row><div class=col-md-12><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12 main-content\"><div ng-bind-html=\"shCtrl.globalParams.cmsInfo.TERMINOS_Y_CONDICIONES | toTrusted\"></div></div></div></div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/static-views/views/terms.html
 ** module id = 522
 ** module chunks = 8
 **/